/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import { Field } from 'redux-form/immutable';
import { Map } from 'immutable';

import FormCheckbox from 'retired/FormCheckbox';

import Option from './Option';

const Options = ({
  fields,
  meta: { error, submitFailed },
  questionType,
  sections,
  showNextSections,
  allowMultiple,
  question,
  isSurvey,
}) => {
  const { move } = fields;
  return (
    (questionType === 'MultipleChoice' || questionType === 'SelectOneDropdown') && (
      <div style={{ paddingLeft: 15 }}>
        {submitFailed && error && <span>{error}</span>}
        {fields.map((option, index) => {
          const remove = () => fields.remove(index);
          const item = fields.get(index);
          return (
            item && (
              <Option
                key={index} // eslint-disable-line react/no-array-index-key
                option={option}
                questionType={questionType}
                sections={sections}
                showNextSections={showNextSections}
                remove={remove}
                move={move}
                index={index}
                allowMultiple={allowMultiple}
                isSurvey={isSurvey}
              />
            )
          );
        })}
        {questionType === 'MultipleChoice' && (
          <div style={{ marginTop: 5 }}>
            <Field
              name={`${question}.typeConfiguration.allowMultiple`}
              component={FormCheckbox}
              label="Allow multiple answers"
            />
          </div>
        )}
        <Button
          variant="outlined"
          onClick={() => fields.push(new Map({ title: '' }))}
          size="small"
          style={{ marginTop: 15, paddingRight: 15 }}
        >
          <AddIcon />
          Add option
        </Button>
      </div>
    )
  );
};
export default Options;
